"use strict";
(function bindLoadEventToImages(global) {
  $("img")
    .one("load", function markImagesLoaded() {
      $(this).addClass("loaded");
    })
    .filter(":not(.unloaded)")
    .each(function refireLoadEventOnCompleteImages() {
      if (this.complete) {
        $(this).trigger("load");
      }
    });
})(window);

(function handleOnSiteLocationChangesInternally() {
  // Catch all internal links to prevent from opening in safari
  // Instead of current app window

  if (navigator.standalone) {
    $('a:not([target="_blank"])').on(
      "click",
      function handleClicksOnInternalLinks(event) {
        var href = $.trim($(this).attr("href"));
        event.preventDefault();
        event.stopPropagation();
        document.location.href = href;
      }
    );
  }
})();

(function (global) {
  var $body = $("body");
  var $navContainer = $(".nav__main");
  var $navToggle = $(".header-bar");
  var $navList = $navContainer.find("ul");
  var $mainNavButton = $(".header__menu");

  var updateNavButtonAria = function () {
    if (global.innerWidth >= 960) {
      if ($body.hasClass("large__nav__open")) {
        $mainNavButton.attr("aria-expanded", true);
      } else {
        $mainNavButton.attr("aria-expanded", false);
      }
    } else {
      if ($body.hasClass("nav__open")) {
        $mainNavButton.attr("aria-expanded", true);
      } else {
        $mainNavButton.attr("aria-expanded", false);
      }
    }
  };

  global.toggleNav = function toggleNav(e, elm) {
    if (global.innerWidth >= 960) {
      $body.toggleClass("large__nav__open");
      $body.removeClass("nav__open");
    } else {
      $body.toggleClass("nav__open");
      if ($body.hasClass("nav__open")) {
        $body.addClass("large__nav__open");
      }
    }
    updateNavButtonAria();
    $navList.scrollTop(0);
    $("html,body").scrollTop(0);
  };

  if ($navContainer.length && $navToggle.length && $mainNavButton.length) {
    updateNavButtonAria();

    // Toggle Nav on large screens only via click on header bar
    $(".header__menu").on("click", function (event) {
      event.preventDefault();
      // event.stopPropagation();
    });
    $navToggle.on("click", toggleNav);
    // Open/Close Nav only on smaller screens
    $navContainer.on("click", function () {
      if (global.innerWidth < 960) {
        toggleNav();
      }
    });
    global.addEventListener("resize", function () {
      updateNavButtonAria();
    });

    delete Hammer.defaults.cssProps.userSelect;
    var $swipe = new Hammer($navContainer.get(0), {
      direction: Hammer.DIRECTION_HORIZONTAL,
      threshold: 80,
      pointers: 0,
      prevent_default: false,
      dragBlockHorizontal: true,
      dragBlockVertical: true,
    });

    $swipe.on("panstart", function (e) {
      if (
        "panstart" === e.type &&
        (1 === e.direction || 4 === e.direction || 3 === e.direction)
      ) {
        $body.addClass("nav__open large__nav__open");
      }
    });

    $swipe.on("panend", function (e) {
      if (2 === e.direction) {
        $body.removeClass("nav__open large__nav__open");
      }
    });
  }
})(window);

(function () {
  var initSlides = function () {
    // var delay = 10000;
    // just cycle to next slide on click (and restart when last is reached)
    var $wraps = $(".slides-wrap");
    if (!$wraps.length) {
      return null;
    }
    $.each($wraps, function (index, wrap) {
      var $wrap = $(wrap);
      var $slides = $wrap.find(".slide");
      var slideCount = $slides.length;
      var posCount = 8;
      var startIndex = 0; // Math.floor(Math.random() * slideCount);

      // stop here if not enough header images to cycle through
      if ($slides.length < 2) {
        return;
      }

      var nav = '<ul class="slide-nav">';

      $.each($slides, function (slideIndex, slide) {
        var $slide = $(slide);
        var activeClass = slideIndex === startIndex ? " active" : ""; // activate first slide
        nav += '<li class="slide-nav-item' + activeClass + '"></li>';

        var currentPos =
          parseInt(posCount / 2) - parseInt(slideCount / 2) + slideIndex + 1;
        if (currentPos < 1) {
          currentPos = 1;
        }
        $slide.attr("data-pos", currentPos).addClass("pos-" + currentPos);
      });

      $wrap.attr("data-slides", slideCount);
      $wrap.append(nav);

      // bind click events

      $wrap.on("click", "img", function (e) {
        e.preventDefault();
        e.stopPropagation();
        getNextSlide($wrap);
      });

      $wrap.on("click", ".slide-nav-item", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ("undefined" !== typeof SliderID) {
          clearInterval(SliderID);
        }

        var $navItem = $(this);
        if ($navItem.hasClass("active")) {
          return null;
        }

        var slideIndex = $wrap.find(".slide-nav-item").index($navItem);
        var loadAllImagesInWrap = true;

        setActiveSlide($wrap, slideIndex, loadAllImagesInWrap);
      });

      $wrap.on("click", function (e) {
        if (!$(e.target).parent("figcaption")) {
          e.preventDefault();
        }
        if ("undefined" !== typeof SliderID) {
          clearInterval(SliderID);
        }
      });

      $wrap.on("dragstart", function (e) {
        e.preventDefault();
      });

      delete Hammer.defaults.cssProps.userSelect;
      var $swipe = new Hammer($wrap[0], {
        direction: Hammer.DIRECTION_HORIZONTAL,
        threshold: 80,
        pointers: 0,
        prevent_default: false,
        dragBlockHorizontal: true,
        dragBlockVertical: true,
      });

      $swipe.on("panstart", function (e) {
        if ("undefined" !== typeof SliderID) {
          clearInterval(SliderID);
        }
        if (2 === e.direction) {
          getNextSlide($(e.target).parents(".slides-wrap"));
        } else if (4 === e.direction) {
          getPrevSlide($(e.target).parents(".slides-wrap"));
        } else if (
          "tap" === e.type ||
          "press" === e.type ||
          "click" === e.type
        ) {
          $(e.target).trigger("click");
        }
      });
      // var SliderID = setInterval(function () {
      //    getNextSlide($wrap);
      // }
      // , delay);
    });
  };

  var getNextSlide = function setNextSlideActive($wrap) {
    if (!$wrap.length) {
      return null;
    }
    var $slideContainer = $wrap.find(".slide-container");
    var $activeSlide = $slideContainer.find(".slide.active");
    var activeIndex = $slideContainer.find(".slide").index($activeSlide);
    var nextIndex = activeIndex + 1;
    var $slides = $slideContainer.find(".slide");
    if (nextIndex > $slides.length - 1) {
      nextIndex = 0;
    }
    var loadAllImagesInWrap = true;
    setActiveSlide($wrap, nextIndex, loadAllImagesInWrap);
  };

  var getPrevSlide = function setPrevSlideActive($wrap) {
    if (!$wrap.length) {
      return null;
    }
    var $slideContainer = $wrap.find(".slide-container");
    var $activeSlide = $slideContainer.find(".slide.active");
    var activeIndex = $slideContainer.find(".slide").index($activeSlide);
    var nextIndex = activeIndex - 1;
    var $slides = $slideContainer.find(".slide");
    if (nextIndex < 0) {
      nextIndex = $slides.length - 1;
    }
    var loadAllImagesInWrap = true;
    setActiveSlide($wrap, nextIndex, loadAllImagesInWrap);
  };

  var setActiveSlide = function setSlideActive(
    $wrap,
    slideIndex,
    loadAllImagesInWrap
  ) {
    if (!$wrap.length) {
      return null;
    }
    $wrap
      .find(".slide")
      .removeClass("active prev-slide")
      .eq(slideIndex)
      .addClass("active")
      .prevAll(".slide")
      .addClass("prev-slide");
    $wrap
      .find(".slide-nav-item")
      .removeClass("active prev-slide")
      .eq(slideIndex)
      .addClass("active")
      .prevAll(".slide")
      .addClass("prev-slide");
    if (loadAllImagesInWrap && !$wrap.hasClass("loaded")) {
      loadAllSlideImages($wrap);
    }
  };

  var loadSlideImage = function (image) {
    if (typeof image != "object") {
      return null;
    }
    var $image = $(image);
    $image.attr("srcset", $image.attr("data-srcset")).removeClass("unloaded");
    if (typeof window.picturefill == "function") {
      picturefill({
        reevaluate: true,
        elements: [image],
      });
    }
  };

  var loadAllSlideImages = function setSrcAttributesOfAllImagesInWrap($wrap) {
    if (!$wrap.length) {
      return null;
    }
    var $images = $wrap.find(".unloaded");
    $.each($images, function (imageIndex, image) {
      loadSlideImage(image);
    });
    $wrap.addClass("loaded");
  };

  // ------------------------------------------------------------------------

  initSlides();
})();

(function () {
  const initTimedNotes = () => {
    const notes = document.documentElement.querySelectorAll(".note--timed");
    if (!notes.length) {
      return null;
    }

    for (let note of notes) {
      let start = note.dataset.start;
      let end = note.dataset.end;
      // parse dates from date strings 2020-01-01 / 2020-01-01T00:00:00
      let startDate = new Date(start);
      let endDate = new Date(end);
      let nowDate = new Date();

      if (nowDate >= startDate && nowDate <= endDate) {
        note.classList.add("visible");
      } else {
        note.classList.remove("visible");
      }
    }
  };
  initTimedNotes();
  // Check every hour
  setInterval(function () {
    initTimedNotes();
  }, 3600000);
})();
